module.exports = __webpack_public_path__ + "static/zama_god.j_viejo-8798b9a7524e652562942341b7c22ef8.jpg";